export default "__VITE_ASSET__Bt6R2CJN__";